import { FC } from "react";
import { ListOfPartnerOrganisations } from "../../../../redux/slices/shareSite/shareSiteTypes";
import { useTranslation } from "react-i18next";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { stylesShareSite } from "../shareSiteStylesMui/ShareSiteStylesMuiComponents";

type SelectPartnerCardParams = {
  listOfPartnerOrganisations: ListOfPartnerOrganisations | undefined;
  selectedPatner: string;
  setSelectedPartner: (selectedPatnerId: string) => void;
  fetchStoragesOfEachLocationLocationView: (
    orgGeoPointId: string,
    selectedPatner: number,
  ) => void;
  selectedSiteId: string;
  currentOrgId: number;
};

const SelectPartnerCard: FC<SelectPartnerCardParams> = ({
  listOfPartnerOrganisations,
  selectedPatner,
  setSelectedPartner,
  fetchStoragesOfEachLocationLocationView,
  selectedSiteId,
  currentOrgId,
}) => {
  const [t] = useTranslation("global");

  const filterCurrentOrgId = listOfPartnerOrganisations?.data.filter(
    (v) => v.orgId !== currentOrgId,
  );

  return (
    <div className="share-site-first-card">
      <div className="share-site-subtitle">{t("Share_site.question-text")}</div>

      <Box sx={stylesShareSite.selectPartner}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">
            {t("Share_site.select-partner")}
          </InputLabel>
          <Select
            value={selectedPatner}
            label={t("Share_site.select-partner")}
            onChange={(e) => {
              setSelectedPartner(e.target.value);
              fetchStoragesOfEachLocationLocationView(
                selectedSiteId,
                e.target.value as any,
              );
            }}
          >
            {filterCurrentOrgId?.map((values) => (
              <MenuItem key={values.orgId} value={values.orgId}>
                {values.customerFacingName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </div>
  );
};

export default SelectPartnerCard;
